export default {
    /**
     * Sets RFI ID.
     *
     * @param state Vuex state
     * @param id RFI ID
     */
    SET_RFI_ID (state, id) {
        state.id = id;
    },

    /**
     * Sets RFI conversations.
     *
     * @param state Vuex state
     * @param conversations RFI conversations array
     */
    SET_RFI_CONVERSATIONS (state, conversations) {
        state.conversations = conversations;
    },

    /**
     * Resets RFI state to initial one.
     *
     * @param state Vuex state
     */
    RESET_RFI (state) {
        state.id = null;
        state.isLoading = true;
        state.activeConversation = null;
        state.conversations = [];
        state.searchQuery = '';
        state.recipients = [];
        state.errors.input = {};
    },

    /**
     * Sets search query.
     *
     * @param state Vuex state
     * @param query Search query term
     */
    SET_RFI_SEARCH_QUERY (state, query) {
        state.searchQuery = query.toLowerCase().trim();
    },

    /**
     * Sets RFI allowed recipients.
     *
     * @param state Vuex state
     * @param recipients Allowed recipients array
     */
    SET_RFI_RECIPIENTS (state, recipients) {
        state.recipients = recipients;
    },

    /**
     * Updates RFI conversation or adds if not found.
     *
     * @param state Vuex state
     * @param conversation RFI conversation
     */
    UPDATE_RFI_CONVERSATION (state, conversation) {
        let conversationIndex = null;

        for (let i = 0; i < state.conversations.length; i++) {
            if (state.conversations[i].id === conversation.id) {
                conversationIndex = i;

                break;
            }
        }

        if (conversationIndex !== null) {
            state.conversations.splice(conversationIndex, 1, conversation);
        } else {
            state.conversations.unshift(conversation);
        }
    },

    /**
     * Sets RFI loading state.
     *
     * @param state Vuex state
     * @param isLoading Is loading
     */
    SET_RFI_LOADING (state, isLoading) {
        state.isLoading = isLoading;
    },

    /**
     * Sets validation errors for RFI input fields.
     *
     * @param state State object
     * @param data Data object
     */
    SET_RFI_INPUT_ERRORS: function (state, data) {
        state.errors.input = data;
    },

    /**
     * Sets active conversation
     *
     * @param state State object
     * @param data Data object
     */
    SET_RFI_ACTIVE_CONVERSATION: function (state, data) {
        state.activeConversation = data;
    },
};
